'use strict';

/**
* @ngdoc service
* @name tcApp.WebsysListBoxesLegacyScope
* @description
* Contains systemUI equivalents for legacy functions originally defined in websys.listboxes.js
*
*/
angular.module('tc.legacyScope').factory('WebsysListBoxesLegacyScope', function($log, tcConstants, LegacyScopeUtilsService) {

	/* eslint no-unused-vars:0 */
	return function($scope, optionSelectedPropertyDefinition) {
		// helper functions for listbox form interactions
		var resetFormItemValidity = function(item, resetInvalidListboxOption) {
			var validityState = {
				'serverError': true,
				'serverWarning': true,
				'serverInformation': true,
				'invalid': true
			};
			if (resetInvalidListboxOption) validityState['invalidListboxOption'] = true;
			LegacyScopeUtilsService.setInputValidity($scope, item, validityState);
		};

		var setFormItemDirty = function(itemName) {
			// doesn't need to worry about form being undefined on load,
			// because whole form gets set to pristine on load anyways,
			// so anything done by this function gets overwritten regardless
			var componentForm = $scope.componentForm[$scope.componentHtmlName];

			if (componentForm && angular.isDefined(componentForm[itemName])) {
				componentForm[itemName].$setDirty();
			}
		};

		/* websys.listboxes.js functions */

		// Removes all options from a listbox
		var clearAllList = function(item) {
			if ((item) && (angular.isArray(item.options))) {
				if (item.options.length) setFormItemDirty(item.id);

				item.options = [];

				resetFormItemValidity(item, true);
			}
		};

		// Receives one array for the listbox values (aryval) and another for its text (arytxt).
		// It then adds these to the required listbox (item)
		var addItemToList = function(item, arytxt, aryval) {
			if ((item) && (angular.isArray(item.options)) && (arytxt.length) && (arytxt[0] !== '')) {
				angular.forEach(arytxt, function(caption, index) {
					addItemSingle(item, aryval[index], caption);
				});
			}
		};

		// Converts delimited strings to an array in preperation for sending to AddItemToList
		var callAddItemToList = function(obj, txtstr, valstr, fcs, delim, descdelim) {
			if ((!delim) || (delim == '')) delim = ',';
			if ((!descdelim) || (descdelim == '')) descdelim = ',';
			var arytxt = txtstr.split(descdelim);
			var aryval = valstr.split(delim);
			var arytxtNew = [];
			var aryvalNew = [];
			var k = 0;
			var match = 0;
			//KM 13-Jul-2002: check for duplicates
			for (var j = 0; j < aryval.length; j++) {
				match = 0;
				for (var i = 0; i < obj.length; i++) {
					if (obj.options[i].value == aryval[j]) {
						match = 1;
						break;
					}
				}
				if (match == 0) {
					aryvalNew[k] = aryval[j];
					arytxtNew[k] = arytxt[j];
					k++;
				}
			}
			addItemToList(obj, arytxtNew, aryvalNew);
		};

		// Adds a single item to a listbox without checking uniqueness
		var addItemSingle = function(item, value, caption) {
			if ((item) && (angular.isArray(item.options))) {
				setFormItemDirty(item.id);

				var itemToAdd = {
					value: value,
					caption: caption,
					selected: true,
					text: caption
				};

				if (angular.isArray(item.valueList)) {
					if (!item.valueList.find(function(valueItem) {
						return (valueItem.value == value);
					})) {
						item.invalidOptionText = caption;
						LegacyScopeUtilsService.setInputValidity($scope, item, 'invalidListboxOption', false);
						return;
					}
				}

				// Use non-mutating concat to get a new array reference due to problems in md-chips change detection
				item.options = item.options.concat(itemToAdd);

				// don't reset listboxOptionInvalid in case an earlier call
				// to this function set it earlier (e.g. as part of addItemToList)
				resetFormItemValidity(item, false);
			}
		};

		// Takes the returned value from a LookUp and formats it for processing by the AddItemToList function
		var transferToList = function(item, val, delim, IDPosition) {
			if ((!delim) || (delim === '')) delim = ',';
			if ((!IDPosition) || (IDPosition == '')) IDPosition = 1;	// For StandardTypes pass IDPosition as 2
			var found = 0;
			if (val !== '') {
				var ary = val.split('^');
				var arytxt = ary[0].split(delim);
				var aryval = ary[IDPosition].split(delim);

				if (!item.options.some(function(option) {
					return (option.value == ary[1]);
				})) {
					addItemToList(item, arytxt, aryval);
				}
			}
		};

		// Converts options in a listbox to a delimited string for a Lookup
		var listToString = function(item, delim, delim2) {
			if ((!delim) || (delim == '')) {
				delim = ',';
			}
			if ((!delim2) || (delim2 == '')) {
				delim2 = '^';
			}

			var arytxt = [];
			var aryval = [];
			angular.forEach(item.options, function(option) {
				arytxt.push(option.text);
				aryval.push(option.value);
			});

			return (arytxt.join(delim) + delim2 + aryval.join(delim));
		};

		// Returns an array of values for options in a listbox
		var returnValues = function(item) {
			var values = [];
			if ((item) && (angular.isArray(item.options))) {
				values = item.options.map(function(option) {
					return option.value;
				});
			}
			return values;
		};

		var selectOptions = function() {
			$log.warn($scope.componentName, 'Call to selectOptions');
		};

		var upClick = function() {
			$log.warn($scope.componentName, 'Call to UpClick');
		};

		var downClick = function() {
			$log.warn($scope.componentName, 'Call to DownClick');
		};

		var swap = function() {
			$log.warn($scope.componentName, 'Call to Swap');
		};

		var swapToList = function() {
			$log.warn($scope.componentName, 'Call to SwapToList');
		};

		// Takes an array (aryval) and searches another array (aryallval) for matches
		// Returns array of corresponding text values
		var loopArrayForMatches = function(aryallval, aryalltxt, aryval) {
			var arytxt = [];
			var count = 0;
			for (var i = 0; i < aryallval.length; i++) {
				for (var j = 0; j < aryval.length; j++) {
					if (aryallval[i] == aryval[j]) {
						arytxt[count] = aryalltxt[i];
						count++;
					}
				}
			}
			return arytxt;
		};

		// Returns whether the specified value is in a listbox
		var findValInList = function(item, val) {
			if ((angular.isUndefined(val))
				|| (!angular.isObject(item))
				|| (!angular.isArray(item.options))) return false;

			// explicitly use weak equals so that numeric strings will match numbers and vice versa
			return !!item.options.find(function(option) { return option.value == val; });
		};

		// Returns the index for the specified value in a listbox
		var getIndexByVal = function(item, val) {
			if ((!item) || (!angular.isArray(item.options))) return -1;
			return item.options.findIndex(function(option) { return option.value === val; });
		};

		var shift = function() {
			$log.warn($scope.componentName, 'Call to Shift');
		};

		// Returns an array of indices of all selected options in a listbox
		var getSelectedListItems = function(item) {
			if ((!item) || (!item.options)) return null;

			return item.options.map(function(_, index) {
				return index;
			});
		};

		// Sets all options in a listbox to the specified state
		var websysListBoxesSelectAll = function(item, state) {
			if (angular.isUndefined(state)) state = true;
			if (!state) {
				clearAllList(item);
			} else {
				// Add eveything from valueList not already in options
				if ((item) && (angular.isArray(item.valueList))) {
					angular.forEach(item.valueList, function(valueListItem) {
						websysListBoxesAddUniqueItemToList(item, valueListItem.caption, valueListItem.value);
					});
				}
			}
		};

		// Adds a unique item to a list box
		var websysListBoxesAddUniqueItemToList = function(item, caption, value) {
			if ((item) && (angular.isArray(item.options))) {
				if (item.options.some(function(option) {
					return (option.value == value);
				})) {
					return false;
				}
				addItemSingle(item, value, caption);
			}
		};

		// Return all the functions in an object
		var websysListBoxesFunctions = {
			'ClearAllList': clearAllList,
			'ClearSelectedList': clearAllList,
			'AddItemToList': addItemToList,
			'callAddItemToList': callAddItemToList,
			'AddItemSingle': addItemSingle,
			'TransferToList': transferToList,
			'ListToString': listToString,
			'returnValues': returnValues,
			'loopArrayForMatches': loopArrayForMatches,
			'FindValInList': findValInList,
			'GetIndexByVal': getIndexByVal,
			'GetSelectedListItems': getSelectedListItems,
			'websysListBoxes_selectAll': websysListBoxesSelectAll,
			'websysListBoxes_AddUniqueItemToList': websysListBoxesAddUniqueItemToList,

			/* Not implemented */
			'selectOptions': selectOptions,
			'UpClick': upClick,
			'DownClick': downClick,
			'Swap': swap,
			'SwapToList': swapToList,
			'Shift': shift,
		};

		return websysListBoxesFunctions;
	};
});
